import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';

const Section = ({ title, iconClass, children, defaultOpen }) => {
  const [open, setOpen] = useState(!!defaultOpen);

  return (
    <div className="prop-section">
      <button
        className={`prop-section-header${open ? ' open' : ''}`}
        onClick={() => setOpen(o => !o)}
        aria-expanded={open}
        type="button"
      >
        <i className={`prop-section-icon fa ${iconClass}`} aria-hidden="true" />
        <span className="prop-section-title">{title}</span>
        <i className="prop-section-chevron fa fa-chevron-down" aria-hidden="true" />
      </button>
      {open && <div className="prop-section-body">{children}</div>}
    </div>
  );
};

const PropertyInfo = ({ property }) => {
  const { t } = useTranslation();
  const {
    aboutInfoText,
    amenities,
    checkinDetailsInfoText,
    cancelationPolicyInfoText,
    termsInfoText,
  } = property;

  const hasAbout      = !!aboutInfoText;
  const hasAmenities  = amenities && amenities.length > 0;
  const hasCheckin    = !!checkinDetailsInfoText;
  const hasCancelation = !!cancelationPolicyInfoText;
  const hasTerms      = !!termsInfoText;

  if (!hasAbout && !hasAmenities && !hasCheckin && !hasCancelation && !hasTerms) {
    return null;
  }

  return (
    <div className="prop-info-accordion">
      {hasAbout && (
        <Section
          title={t('propertyInfo.about')}
          iconClass="fa-info-circle"
          defaultOpen
        >
          <div className="prop-section-text">{parse(aboutInfoText)}</div>
        </Section>
      )}

      {hasAmenities && (
        <Section
          title={t('propertyInfo.amenities')}
          iconClass="fa-star-o"
          defaultOpen
        >
          <ul className="prop-amenities-list list-unstyled m-0">
            {amenities
              .sort((a, b) => (a.label < b.label ? -1 : a.label > b.label ? 1 : 0))
              .map((amenity, i) => (
                <li key={`pinfo-amenity-${i}`} className="prop-amenity-item">
                  <span className={amenity.icon} aria-hidden="true" />
                  <span className="prop-amenity-label">{amenity.label}</span>
                </li>
              ))}
          </ul>
        </Section>
      )}

      {hasCheckin && (
        <Section
          title={t('propertyInfo.checkin')}
          iconClass="fa-clock-o"
        >
          <div className="prop-section-text">{parse(checkinDetailsInfoText)}</div>
        </Section>
      )}

      {hasCancelation && (
        <Section
          title={t('propertyInfo.cancelation')}
          iconClass="fa-times-circle-o"
        >
          <div className="prop-section-text">{parse(cancelationPolicyInfoText)}</div>
        </Section>
      )}

      {hasTerms && (
        <Section
          title={t('propertyInfo.terms')}
          iconClass="fa-file-text-o"
        >
          <div className="prop-section-text">{parse(termsInfoText)}</div>
        </Section>
      )}
    </div>
  );
};

export default PropertyInfo;
